import React, { useEffect, useState } from 'react'
import {   Form, Space, Table,  Flex, Input } from 'antd'; 
import Icon from '../../cpn/Icon';
import Main from '../../cpn/Main';
import ClientAdd from './ClientAdd';
import { useKehuListQuery } from '../../store/DianShangYeWuApi';
import ClientTypeSelect from '../clientType/ClientTypeSelect';  
import ClientCheck from './ClientCheck';
import classes from '../system.module.css';
import ClientAddMulti from './ClientAddMulti';
function ClientList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const [query,setQuery] = useState({
        kh_qy_id:qy_id,
        kh_name:'',
    })
    const {data, isSuccess} = useKehuListQuery(query,{refetchOnMountOrArgChange:true});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {kh_id:key,kh_name,kh_cname,kh_ctime,kh_type_name,kh_type_id,kh_remark,kh_update_time,kh_update_uname} = item;                 
                    return item = {key,kh_name,kh_cname,kh_ctime,kh_type_name,kh_type_id,kh_remark,kh_update_time,kh_update_uname}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.kh_ctime;
                    let bTimeString = b.kh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'kh_name',
            title: '名称',            
            dataIndex: 'kh_name',
            render: (text, record) => <ClientCheck kh_id={record.key} kh_name={record.kh_name} qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} />
        },              
        {
            key: 'kh_type_name',
            title: '类型',            
            dataIndex: 'kh_type_name',
        },              
        {
            key: 'kh_remark',
            title: '备注',            
            dataIndex: 'kh_remark',
        },                     
        {
            key: 'key',
            title: '编号',
            dataIndex: 'key',
        },
    ]   
    const [form] = Form.useForm();
    return (
        <Main selectedKeys={['/ClientList']}>                       
            <Flex align='center' justify='space-between' gap={10}>
                <Form
                    layout='inline'
                    form={form}
                    onFinish={(values) => {   
                        setQuery({...query,kh_name:values.kh_name,kh_type_id:values.kh_type_id,kh_remark:values.kh_remark})
                    }}
                    initialValues={{
                        kh_name:'',
                        kh_type_id:'',
                        kh_remark:'',
                    }}
                >
                    <Form.Item name='kh_name'>
                        <Input placeholder='请输入名称' />
                    </Form.Item>                    
                    <Form.Item name='kh_type_id'>
                        <ClientTypeSelect
                            wrapperCol={null}
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={yh_id}
                            yh_name={yh_name}
                            onChange={() => {}}
                            style={{width:'200px'}}
                            placeholder='请选择客户类型'
                        />
                    </Form.Item>
                    <Form.Item name='kh_remark'>
                        <Input placeholder='请输入备注' />
                    </Form.Item>                    
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'  onClick={() => {
                                form.resetFields();
                                setQuery({...query,kh_name:'',kh_type_id:'',kh_remark:''})
                            }}/>                            
                            
                        </Space>
                    </Form.Item>
                </Form>
                <Space>
                    <ClientAdd 
                        qy_id={qy_id}
                        qy_name={qy_name}
                        yh_id={yh_id}
                        yh_name={yh_name}
                    />
                    <ClientAddMulti 
                        qy_id={qy_id}
                        qy_name={qy_name}
                        yh_id={yh_id}
                        yh_name={yh_name}
                    />
                </Space>
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className={classes.customTable}
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default ClientList
